import { Directive, Input, ViewContainerRef, TemplateRef } from '@angular/core';
import { SessionDataService } from 'inova-front-core/session';

@Directive({
  selector: '[requirePermission]'
})
export class InovaRequirePermissionDirective {

  @Input('requirePermission') set requirePermission(permission: string) {
    if (this.sessionService.userHasPermission(permission)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
    else{
      this.viewContainer.clear();
    }
  }

  constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef, private sessionService:SessionDataService) {
  }
}
